import React, {useEffect, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import {ModalStateType} from "./interface";
import {useModal} from "../../../hooks";
import {useLocation} from "react-router-dom";

type Props = {
    modalState: ModalStateType;
};

export const CustomModal = (props: Props) => {
    const {
        isOpen,
        contents,
        type,
        depth = 1,
        callback,
        closeAction,
        className,
        title = type === "alert" ? "알림" : type === "confirm" ? "확인" : "",
        noHeader,
        noCloseBtn,
        modalSize = "sm",
    } = props.modalState;

    const location = useLocation();
    const modalRef = useRef<HTMLDivElement | null>(null);
    const zIndex = depth === 1
        ? 1050
        : depth === 2
            ? 1060
            : depth === 3
                ? 1070
                : depth === 4
                    ? 1080
                    : depth === 5
                        ? 1090
                        : 9999
    const {resetModal} = useModal();

    useEffect(() => {
        if (isOpen) {
            resetModal(depth);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (modalRef?.current) {
            modalRef?.current?.scrollTo(0, 0); // 스크롤을 (0, 0)으로 설정
        }
    }, [contents]);

    const confirm = () => {
        callback && callback();
        resetModal(depth)
    }

    const close = () => {
        closeAction && closeAction();
        resetModal(depth);
    };

    const bootstrapModalSize: "sm" | "lg" | "xl" | undefined =
        modalSize === "xxl" ? undefined : modalSize;

    return (
        isOpen && (
            <Modal
                className={`my_modal z-index-${zIndex} ${className ?? ""} ${modalSize === "xxl" ? "modal-xxl" : ""}`}
                backdropClassName={`backdrop-z-index-${zIndex}`}
                show={isOpen}
                onHide={close}
                centered
                size={bootstrapModalSize}
            >
                {!noHeader && (
                    <Modal.Header closeButton={!noCloseBtn}>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                )}

                <Modal.Body>
                    {typeof contents === "string"
                        ? <div
                            className="modal-body-content">{contents}</div>
                        : contents}
                </Modal.Body>

                {type !== "" && (
                    <Modal.Footer className={`border-0 custom_modal ${type === "confirm" ? "btn2" : ""}`}>
                        {type === "alert" &&
                            <button type="button" className="btn btn-info" onClick={close}>확인</button>}
                        {type === "confirm" && <>
                            <button type="button" className="btn btn-light" onClick={close}>
                                취소
                            </button>
                            <button type="button" className="btn btn-info" onClick={confirm}>
                                확인
                            </button>
                        </>}
                    </Modal.Footer>
                )}
            </Modal>
        )
    );
};
